/* Different Drips — gallery navigation that survives variant re-renders.
   Dawn binds thumbnail clicks in media-gallery's constructor; when a variant
   change rebuilds the gallery's children those bindings die. This delegated
   handler owns BOTH thumbnail clicks and the overlay arrows. */
(function () {
  window.__ddGalleryDebug = [];
  function dbg(m) {
    window.__ddGalleryDebug.push(m);
    if (window.__ddGalleryDebug.length > 30) window.__ddGalleryDebug.shift();
  }

  function visibleThumbTargets(gallery) {
    var all = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list [data-target]'));
    var visible = all.filter(function (btn) {
      var item = btn.closest('.thumbnail-list__item');
      if (!item) return true;
      if (getComputedStyle(item).display === 'none') return false;
      return item.getBoundingClientRect().height > 0;
    });
    return visible.length ? visible : all;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (window.matchMedia('(max-width: 989px)').matches) return;

      /* thumbnail clicks (delegated, replaces Dawn's constructor binding) */
      var thumb = event.target.closest('.product--thumbnail media-gallery .thumbnail-list [data-target]');
      if (thumb) {
        if (window.__ddRailMoved) {
          window.__ddRailMoved = false;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        var galleryT = thumb.closest('media-gallery');
        dbg('thumb:' + thumb.dataset.target);
        if (galleryT && typeof galleryT.setActiveMedia === 'function') {
          event.preventDefault();
          event.stopPropagation();
          galleryT.setActiveMedia(thumb.dataset.target, false);
        }
        return;
      }

      /* overlay arrows */
      var button = event.target.closest(
        '.product--thumbnail media-gallery > slider-component:not(.thumbnail-slider) .slider-button'
      );
      if (!button) return;
      var gallery = button.closest('media-gallery');
      dbg('arrow:' + button.name + ' gallery:' + !!gallery);
      if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

      event.preventDefault();
      event.stopPropagation();

      var thumbButtons = visibleThumbTargets(gallery);
      if (!thumbButtons.length) {
        dbg('no-thumbs');
        return;
      }

      var activeItem = gallery.querySelector('.product__media-item.is-active');
      var activeId = activeItem ? activeItem.dataset.mediaId : null;
      var currentIndex = thumbButtons.findIndex(function (t) {
        return t.dataset.target === activeId;
      });
      if (currentIndex < 0) currentIndex = 0;

      var nextIndex =
        button.name === 'next'
          ? (currentIndex + 1) % thumbButtons.length
          : (currentIndex - 1 + thumbButtons.length) % thumbButtons.length;

      dbg('move:' + currentIndex + '->' + nextIndex + ' target:' + thumbButtons[nextIndex].dataset.target);
      gallery.setActiveMedia(thumbButtons[nextIndex].dataset.target, false);

      var item = thumbButtons[nextIndex].closest('.thumbnail-list__item');
      if (item && item.scrollIntoView) {
        item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    },
    true
  );

  /* Drag-to-scroll on the vertical thumbnail rail (invisible scroll) */
  function initRailDrag() {
    document
      .querySelectorAll('.product--thumbnail media-gallery > .thumbnail-slider .thumbnail-list')
      .forEach(function (list) {
        if (list.dataset.ddDrag) return;
        list.dataset.ddDrag = 'true';
        var down = false;
        var moved = false;
        var startY = 0;
        var startTop = 0;

        list.addEventListener('pointerdown', function (e) {
          if (window.matchMedia('(max-width: 989px)').matches) return;
          down = true;
          moved = false;
          startY = e.clientY;
          startTop = list.scrollTop;
        });
        window.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dy = e.clientY - startY;
          if (Math.abs(dy) > 5) {
            moved = true;
            window.__ddRailMoved = true;
            list.classList.add('dd-dragging');
          }
          list.scrollTop = startTop - dy;
        });
        window.addEventListener('pointerup', function () {
          down = false;
          list.classList.remove('dd-dragging');
        });
        list.addEventListener(
          'click',
          function (e) {
            if (moved) {
              e.preventDefault();
              e.stopPropagation();
              moved = false;
            }
          },
          true
        );
      });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRailDrag);
  } else {
    initRailDrag();
  }
})();
